
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.164 1.711a1.87 1.87 0 0 1 1.306-.527c.49 0 .96.19 1.306.527.346.338.54.796.54 1.274l-.002 4.91a.9.9 0 0 1-.27.638.94.94 0 0 1-.654.263.94.94 0 0 1-.653-.263.9.9 0 0 1-.27-.637V4.428"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M6.343 3.033H4.79c-.683 0-1.236.54-1.236 1.206v10.465c0 .666.553 1.206 1.236 1.206h7.417c.683 0 1.236-.54 1.236-1.206V4.239"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M6.295 12.508h4.41m-4.41-3H7.45m-1.155-3h1.017"}})])
          )
        }
      }
    